import styled from 'styled-components'

export const StyledListItem = styled.li`
    list-style: none;
`